import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import StockLoader from '../components/StockLoader';

const LoaderContext = createContext(null);

export function LoaderProvider({ children }) {
    const [count, setCount] = useState(0);

    const show = useCallback(() => setCount(c => c + 1), []);
    const hide = useCallback(() => setCount(c => Math.max(0, c - 1)), []);

    const value = useMemo(() => ({ show, hide, active: count > 0 }), [show, hide, count]);

    return (
        <LoaderContext.Provider value={value}>
            {children}
            {count > 0 && (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    pointerEvents: 'none',
                    background: 'rgba(255,255,255,0.45)'
                }}>
                    <div style={{ pointerEvents: 'auto' }}>
                        <StockLoader size={84} />
                    </div>
                </div>
            )}
        </LoaderContext.Provider>
    );
}

export const useLoader = () => useContext(LoaderContext);